import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
const hcnd = require('highcharts/modules/no-data-to-display');

hcnd(Highcharts);

Highcharts.setOptions({
  global: {
    useUTC: false,
  },
});

const options = {
  chart: {
    type: 'column',
    height: 400,
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 30,
        },
        chartOptions: {
          legend: {
            enabled: false,
          },
        },
      },
    ],
  },
  title: {
    text: 'Health Index by feeder',
  },
  rangeSelector: {
    selected: 4,
    inputEnabled: false,
    buttonTheme: {
      visibility: 'hidden',
    },
    labelStyle: {
      visibility: 'hidden',
    },
  },
  credits: {
    enabled: false,
  },
  xAxis: {
    type: 'text',
    categories: '',
  },
  yAxis: {
    title: {
      text: '',
    },
  },
  exporting: {
    enabled: true,
    buttons: {
      contextButton: {
        menuItems: [
          'downloadPNG',
          'downloadJPEG',
          'downloadPDF',
          'downloadSVG',
          'separator',
          'downloadCSV',
          'downloadXLS',
          'viewData',
        ],
      },
    },
  },
  legend: {
    enabled: true,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom',
  },
  navigator: {
    enabled: false,
    reversed: false,
  },
  tooltip: {
    pointFormat:
      '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b><br/>',
    valueDecimals: 0,
    split: true,
  },
  plotOptions: {
    column: {
      stacking: 'normal',
    },
  },
  series: [],
  lang: {
    noData: 'No data found to display!',
  },
  noData: {
    position: {
      x: 0,
      y: 0,
      align: 'center',
      verticalAlign: 'middle',
    },
  },
};

class HealthIndexFeeder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options,
    };
  }

  componentDidMount() {
    this.drawChart(this.props.data);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.drawChart(nextProps.data);
  }

  drawChart(data) {
    try {
      const FeederName = [];
      const H1 = [];
      const H2 = [];
      const H3 = [];
      const H4 = [];
      const H5 = [];
      let clrObj;

      data.forEach((element) => {
        FeederName.push(element.FeederName);
        H1.push(element.HI1);
        H2.push(element.HI2);
        H3.push(element.HI3);
        H4.push(element.HI4);
        H5.push(element.HI5);
        clrObj = {
          HI1Color: element.HI1Color,
          HI2Color: element.HI2Color,
          HI3Color: element.HI3Color,
          HI4Color: element.HI4Color,
          HI5Color: element.HI5Color,
        };
      });

      const tmpOptions = this.state.options;
      tmpOptions.FeederName = FeederName;
      tmpOptions.series = [
        {
          name: 'HI1',
          data: H1,
          color: clrObj.HI1Color,
        },
        {
          name: 'HI2',
          data: H2,
          color: clrObj.HI2Color,
        },
        {
          name: 'HI3',
          data: H3,
          color: clrObj.HI3Color,
        },
        {
          name: 'HI4',
          data: H4,
          color: clrObj.HI4Color,
        },
        {
          name: 'HI5',
          data: H5,
          color: clrObj.HI5Color,
        },
      ];

      this.setState({
        options: tmpOptions,
      });
    } catch (err) {
      console.log(err);
    }
  }

  render() {
    return (
      <div>
        {
          <HighchartsReact
            highcharts={Highcharts}
            constructorType={'stockChart'}
            options={this.state.options}
          />
        }
      </div>
    );
  }
}
export default HealthIndexFeeder;
